<template>
<v-row>
    <v-col cols="1"></v-col>
    <v-col cols="10">
        <v-card-text class="">
            <h2 class="indigo--text text--darken-4"><u>Expériences professionnelles</u></h2>
            <br>
            <v-timeline align-top>
                <v-timeline-item v-for="(item, i) in items" :key="i" color="indigo darken-4">
                    <v-card class="blue-grey lighten-3">
                        <v-card-title class="blue-grey lighten-4 indigo--text text--darken-4">
                            <span class="text-left"><small>[{{ item.start.getFullYear() }} - {{ item.end.getFullYear() }}]</small> {{ getDuration(item.end, item.start)   }} an(s) : {{ item.value }}</span>
                        </v-card-title>
                        <v-card-text class="pt-5 blue-grey lighten-5 grey--text text--darken-3">
                            <ul class="fa-ul">
                                <li v-for="(task, t) in item.tasks" :key="t" class="text-left">
                                    <span class="fa-li">
                                        <i class="fas fa-long-arrow-alt-right fa-s"></i>
                                    </span>
                                    <span v-html="task.value"></span>
                                </li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </v-card-text>
    </v-col>
    <v-col cols="1"></v-col>
</v-row>
</template>

<script>
export default {
    name: 'Jobs',
    data: () => ({
        items: [
            {
                name: 'erasmus',
                value: 'Agence Erasmus+ France / Education Formation',
                location: 'Bordeaux',
                title: 'Ingénieur Développement',
                start: new Date('2019-04'),
                end: new Date(),
                tasks: [
                    { value: '<strong>Elaboration</strong> du nouvel outil backoffice de l\'Agence (Laravel/VueJS)'},
                    { value: 'Mise en place du <strong>versionning de code</strong> (Git via Bitbucket)'},
                    { value: '<strong>Correction de bugs</strong> sur l\'ancien outil backoffice(PHP/JQuery)' },
                    { value: 'Rédaction de la <strong>documentation technique</strong>' }
                ]
            },
            {
                name: 'axyus',
                value: 'axYus',
                location: 'Mérignac',
                title: 'Ingénieur Développement',
                start: new Date('2017-03'),
                end: new Date('2019-04'),
                tasks: [
                    { value: '<strong>Création</strong> d\'un module (PHP/Symfony) de gestion de localisation pour une application de défraiements' },
                    { value: '<strong>Correction de bugs et évolutions</strong> (PHP) pour une application de gestion de projets publics européens' }
                ]
            },
            {
                name: 'itema',
                value: 'Item-a',
                location: 'Andernos',
                title: 'Développeur Web',
                start: new Date('2012-05'),
                end: new Date('2016-12'),
                tasks: [
                    { value: '<strong>Résolution des bugs</strong> sur les sites web édités par la société (PHP)' },
                    { value: '<strong>Mise en place de nouvelles fonctionnalités</strong> sur ces mêmes sites web (PHP)' },
                    { value: '<strong>Création d\'un programme</strong> (Python) de validation automatique des photos déposées par les utilisateurs' },
                    { value: '<strong>Réalisation d\'une application</strong> (PHP) de gestion des espaces publicitaires' },
                    { value: '<strong>Mise en place d’outils de suivi et évolutions</strong> sur l’activité emailing (bash,PHP,Python)' }
                ]
            },
            {
                name: 'laser',
                value: 'eLaser / Laser Loyalty',
                location: 'Mérignac / Bordeaux',
                title: 'Assitant Maîtrise d\'Ouvrage',
                start: new Date('2002-11'),
                end: new Date('2011-11'),
                tasks: [
                    { value: '<strong>Analyse des bugs, proposition d\'évolutions, suivi des interventions, tests et recette</strong> sur l\'activité Assurances' },
                    { value: 'Assistance au chef de projet: <strong>rédaction de chapitres de cahier des charges, spécifications fonctionelles</strong>' },
                    { value: '<strong>Administration fonctionnelle</strong> de l\'outil de CRM et Facturation (PeopleSoft)' },
                    { value: '<strong>Création de scripts</strong> (bash) de suivi des traitements récurrents' },
                    { value: '<strong>Développement d\'une interface</strong> (PHP) de traitement de fichiers pour l\'activité Prépayé' }
                ]
            },
            {
                name: 'uranie',
                value: 'Uranie',
                location: 'Bordeaux',
                title: '[Stagiaire] Développeur Web',
                start: new Date('2002-04'),
                end: new Date('2002-06'),
                tasks: [
                    { value: '<p><strong>Réalisation d\'une application</strong> (PHP) de gestion de concours hippiques</p>' }
                ]
            },
            {
                name: 'cyber',
                value: 'Internet Center',
                location: 'Bordeaux',
                title: 'Hôte d\'accueil et technicien',
                start: new Date('2001-09'),
                end: new Date('2002-08'),
                tasks: [
                    { value: '<strong>Accueil, assistance et encaissement</strong> des clients' },
                    { value: '<strong>Maintenance</strong> du parc informatique' },
                    { value: '<strong>Réalisation du logiciel</strong> (VB6) de facturation des clients' }
                ]
                },
                {
            name: 'ifadepe',
            value: 'IFADEPE',
                location: 'Avensan',
                title: '[Stagiaire] Développeur d\'application',
                start: new Date('2001-04'),
                end: new Date('2001-05'),
                tasks: [
                    { value: '<strong>Réalisation d\'un logiciel</strong> (VB6) de base documentaire, permettant d\'enregistrer les propriétés des documents Microsoft Office dans une base de données.' }
                ]
            }
        ]
    }),
    methods: {
        getDuration(date1, date2)
        {
            var diffMs = date1.getTime() - date2.getTime()
            var duration = parseFloat(diffMs / (86400 * 365 * 1000)).toFixed(1)
            
            // arrondis
            var months = parseInt(duration.substring((duration.length-1)))
            var years = parseInt(duration.substring(0, (duration.length-2)))
            if( months<=3 ) {
                return years.toString()
            } else if( months>=7 ) {
                return (years+1).toString()
            } else {
                return years.toString()+'.5'
            }
        }
    }
}
</script>
